export default {
  preferredDeliveryAddresses: [],
  preferredDeliveryAddress: undefined,
};
